var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var SvgDropdown = function SvgDropdown(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 6,
    height: 14,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.924 4.235l-2.5-4a.5.5 0 00-.848 0l-2.5 4A.5.5 0 00.5 5h5a.5.5 0 00.424-.765zm0 5.53l-2.5 4a.5.5 0 01-.848 0l-2.5-4A.5.5 0 01.5 9h5a.5.5 0 01.424.765z",
    fill: "#31353A"
  })));
};

export default SvgDropdown;